<template>
  <v-dialog v-model="dialog" persistent max-width="1200" max-height="80vh">
    <template v-if="!hideActivator" v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <div
            v-bind="tooltip.attrs"
            v-on="!edit && possuiPropostaEmProcessamento && tooltip.on"
          >
            <v-btn
              v-on="on"
              color="primary"
              class="mr-3"
              :disabled="!edit && possuiPropostaEmProcessamento"
            >
              <slot name="title"></slot>
            </v-btn>
          </div>
        </template>
        Não é possível gerar nova proposta, devido à existência de uma
        em processamento.
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="fechar" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text
        class="novaProposta"
        style="max-height: 60vh; overflow-y: auto"
      >
        <v-row>
          <v-col>
            <h3>
              Para {{ !edit ? "gerar" : "editar" }} uma proposta, adicione os
              eixos e soluções abaixo.
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            Eixos do Combo Essencial serão adicionados automaticamente.
          </v-col>
        </v-row>
        <v-row>
          <v-col
            ><ComboboxGroupSolution
              :filter="{
                grupoSolucaoId: atualGrupoSolucao,
              }"
              :title="'Eixos'"
              @changeGroupSolution="changeGroupSolution"
            ></ComboboxGroupSolution>
          </v-col>
          <v-col v-if="atualGrupoSolucao">
            <ComboboxSolution
              :filter="{
                solutions: atualSolutions,
                solucaoId: selectedSolutions,
              }"
              multiple
              @changeSolution="changeSolution"
              @createExtra="openCriarSolucaoExtra"
              returnObject
              :solutionIds="[]"
              :returnExtraTitle="true"
              :showCreateExtra="true"
              :disableCreateExtra="!atualGrupoSolucao"
            ></ComboboxSolution>
            <ModalInsertSolucaoExtra
              ref="modalSolucaoExtra"
              :fixedGrupoSolucaoId="atualGrupoSolucao"
              :disableGroupSelection="true"
              :hideActivator="true"
              @created="handleSolucaoExtraCreated"
            />
          </v-col>
        </v-row>
        <TabelaValores
          :payload="{ ...payload, solucoesFaixasDTO: selectedSolutions }"
          :faixa="faixa"
          :combos="combos"
        ></TabelaValores>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="selectedSolutions"
              class="elevation-1 w-100 proposta"
              hide-default-footer
              disable-pagination
              fixed-header
            >
              <template v-slot:item.nome="{ item }">
                <div>
                  <div>
                    {{ item.nome }}
                  </div>
                  <div
                    style="color: #898686; font-size: 12px; font-style: italic"
                  >
                    {{
                      item.municipioPropostaSolucoesExtrasId
                        ? "(Solução extra) "
                        : ""
                    }}
                  </div>
                </div>
              </template>

              <template v-slot:item.acoes="{ item }">
                <div class="d-flex align-center">
                  <v-btn
                    outlined
                    color="error"
                    class="mr-3"
                    @click="deleteProposta(item)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                  <v-btn color="primary" class="mr-3" @click="duplicar(item)">
                    Duplicar
                  </v-btn>
                </div>
              </template>

              <template slot="no-data">
                <span> Nenhum eixo adicionado </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="fechar">Fechar</v-btn>
        <v-btn color="info" outlined text @click="alert">
          <slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ComboboxGroupSolution from "@/modules/group-solution/components/Combobox.vue";
import ComboboxSolution from "@/modules/solution/components/Combobox.vue";
import { solutionAPI } from "@/modules/solution/components/SolutionAPI";

import { propostaApi } from "@/apis/proposta";
import { municipioPropostaSolucaoExtraApi } from "@/apis/proposta";
import { statusPropostasEnum } from "./statusPropostasEnum";
import moment from "moment";
import { CombosEnum } from "./CombosEnum";
import Swal from "sweetalert2";
import TabelaValores from "./TabelaValores.vue";
import ModalInsertSolucaoExtra from "@/modules/city/components/propostas/solucoesExtras/ModalInsert.vue";

export default {
  name: "ModalNovaProposta",
  components: {
    ComboboxGroupSolution,
    ComboboxSolution,
    TabelaValores,
    ModalInsertSolucaoExtra,
  },
  props: {
    payload: { type: Object, required: true },
    edit: { type: Object, default: () => {} },
    possuiPropostaEmProcessamento: { type: Boolean, default: false },
    hideActivator: { type: Boolean, default: false },
    combos: {
      type: Array,
      default: () => [],
    },
    faixa: { type: Object, default: null },
    solucoesExtras: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(["isFullAdmin", "city", "user"]),
    solucaoEscolhida() {},
    combosEssecialSolutionsId() {
      const comboEssencial =
        this.combos &&
        this.combos.length &&
        this.combos.find(
          (item) => (item.municipioPropostaCombosId = CombosEnum.essencial)
        );

      return (
        (comboEssencial &&
          comboEssencial.solucaoIds &&
          comboEssencial.solucaoIds.split(",")) ||
        []
      );
    },
    ultrapassouValorTeto() {
      return this.faixa && this.faixa.faixaTeto < this.getValorTotalSemExtra;
    },
    getExcedenteTeto() {
      return this.getValorTotalSemExtra - this.getValorTeto;
    },
    getValorTotal() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;
      return this.getSomaSolucoes + valorEssencial;
    },
    getSomaSolucoes() {
      return this.selectedSolutions
        .filter((item) => item.solucaoId)
        .reduce((partialSum, a) => {
          return partialSum + (a.precoFaixa || a.preco || 0);
        }, 0);
    },
    getValorTotalSemExtra() {
      return this.getSomaSolucoes + this.getValorEssencial;
    },
    getValorSebraeSemExtra() {
      return this.getSomaSolucoes + this.getValorEssencial;
    },
    getValorMunicipioSemExtra() {
      return this.getSomaSolucoes + this.getValorEssencial;
    },
    faixaSubsidioPreium() {
      return (this.faixa && this.faixa.subsidioPremium) || 0;
    },
    faixaSubsidio() {
      return (this.faixa && this.faixa.faixaSubsidio) || 0;
    },
    getValorTotal() {
      return (
        this.getSomaSolucoes +
        this.getValorEssencial +
        this.getValorSolucoesExtra.valorTotal
      );
    },
    getValorEssencial() {
      return (this.faixa && this.faixa.valorFaixaEssencial) || 0;
    },
    getValorSolucoesExtra() {
      const extras = this.selectedSolutions.filter(
        (item) => item.municipioPropostaSolucoesExtrasId
      );

      return {
        valorTotal: extras.reduce((partialSum, a) => {
          return partialSum + (a.preco || 0);
        }, 0),
        valorMunicipio: extras.reduce((partialSum, a) => {
          return partialSum + (a.valorMunicipio || 0);
        }, 0),
        valorSebrae: extras.reduce((partialSum, a) => {
          return partialSum + (a.valorSebrae || 0);
        }, 0),
      };
    },

    getValorTeto() {
      return (this.faixa && this.faixa.faixaTeto) || 0;
    },
    getValorSolucoesPorTeto() {
      //  o valor excedente do teto da faixa da proposta é entrado integralmente no investimento do municipio
      if (this.ultrapassouValorTeto) {
        return {
          valorSolucaoAteTeto:
            this.getValorTotalSemExtra -
            this.getValorEssencial -
            this.getExcedenteTeto,
          valorSolucaoAposTeto: this.getExcedenteTeto,
        };
      }

      return {
        valorSolucaoAteTeto: this.getSomaSolucoes,
        valorSolucaoAposTeto: 0,
      };
    },
    getValorContrapartidaSebrae() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio = valorEssencial * (this.faixaSubsidio / 100);

      const valorComSubsidioPremium =
        this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
        (this.faixaSubsidioPreium / 100);

      return (
        valorComSubsidio +
        valorComSubsidioPremium +
        this.getValorSolucoesExtra.valorSebrae
      );
    },
    getValorInvestimentoMunicipal() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio =
        valorEssencial * ((100 - this.faixaSubsidio) / 100);

      const valorComSubsidioPremium =
        this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
        ((100 - this.faixaSubsidioPreium) / 100);

      return (
        valorComSubsidio +
        valorComSubsidioPremium +
        this.getValorSolucoesPorTeto.valorSolucaoAposTeto +
        this.getValorSolucoesExtra.valorMunicipio
      );
    },
  },
  watch: {
    dialog(val) {
      if (val && !!this.edit) {
        this.loadSolutions();
      }

      if (!val) {
        this.fechar();
      }
    },
    solucoesExtras: {
      handler(val) {
        this.solucoesExtrasLocal = val || [];
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      dialog: false,
      atualGrupoSolucao: null,
      atualSolutions: [],
      solutions: [],
      selectedSolutions: [],
      novaProposta: { groupSolution: [] },
      solucoesExtrasLocal: [],
      pendingExtraSelectionId: null,
      headersValores: [
        { text: "", value: "combo", sortable: false },
        {
          text: "Investimento Total",
          value: "investimentoTotal",
          sortable: false,
        },
        {
          text: "Contrapartida Sebrae",
          value: "contrapartidaSebrae",
          sortable: false,
        },
        {
          text: "Investimento Municipal",
          value: "investimentoMunicipal",
          sortable: false,
        },
      ],

      headers: [
        { text: "Grupo", value: "grupoSolucao.nome", align: "center" },
        { text: "Solução", value: "nome", align: "center" },
        { text: "Ações", value: "acoes", align: "center" },
      ],
    };
  },
  mounted() {},

  methods: {
    ...mapActions(["setLoading"]),
    open() {
      this.dialog = true;
    },
    async refreshSolucoesExtras() {
      try {
        const resp = await municipioPropostaSolucaoExtraApi.listByMunicipio(
          this.$route.params.id
        );
        this.solucoesExtrasLocal = resp.data;
        if (this.atualGrupoSolucao) {
          await this.loadSolutionsByGroup(this.atualGrupoSolucao);
        }
        if (this.pendingExtraSelectionId) {
          const novaSolucao = this.solucoesExtrasLocal.find(
            (item) =>
              item.municipioPropostaSolucoesExtrasId ===
              this.pendingExtraSelectionId
          );
          if (novaSolucao) {
            const jaSelecionada = this.selectedSolutions.some(
              (item) =>
                item.municipioPropostaSolucoesExtrasId ===
                novaSolucao.municipioPropostaSolucoesExtrasId
            );
            if (!jaSelecionada) {
              this.selectedSolutions = [...this.selectedSolutions, novaSolucao];
            }
          }
          this.pendingExtraSelectionId = null;
        }
      } catch (error) {
        console.log("Erro ao atualizar soluções extras", error);
      }
    },
    alert() {
      if (this.ultrapassouValorTeto) {
        Swal.fire({
          title: `Atenção!`,
          text: `Você ultrapassou o investimento teto e com isso o valor excedente de ${this.getExcedenteTeto.toLocaleString(
            "pt-br",
            {
              style: "currency",
              currency: "BRL",
            }
          )} será pago integralmente pelo município sem subsídio do Sebrae. Deseja continuar?`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Continuar",
          cancelButtonColor: "#d33",
          showCancelButton: true,
          reverseButtons: true,
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            this.onConfirm();
          }
        });
      } else {
        this.onConfirm();
      }
    },
    duplicar(val) {
      const qd = this.selectedSolutions.filter(
        (item) => item.solucaoId === val.solucaoId
      ).length;

      this.selectedSolutions.push({
        ...val,
        nome: `${val.nome} ${qd + 1}`,
      });
    },
    addSolucao(val) {
      this.selectedSolutions = val.municipioPropostaGrupoSolucao
        .map((id) =>
          this.solutions.find((item) => item.solucaoId === id.idSolucao)
        )
        .filter((i) => i && i.solucaoId);
      const solucoesExtra = val.municipioPropostaGrupoSolucao
        .map((item) =>
          this.solucoesExtrasLocal.find(
            (v) => item.solucaoExtraId == v.municipioPropostaSolucoesExtrasId
          )
        )
        .filter((i) => i && i.municipioPropostaSolucoesExtrasId);

      this.selectedSolutions = [...this.selectedSolutions, ...solucoesExtra];

      const solucoesPrecos =
        (this.faixa &&
          this.faixa.solucoesFaixasDTO &&
          this.faixa.solucoesFaixasDTO.length &&
          this.faixa.solucoesFaixasDTO) ||
        [];

      this.selectedSolutions = this.selectedSolutions.map((val) => {
        const solucaoAtual = solucoesPrecos.find(
          (a) => a.solucaoId == val.solucaoId
        );

        return {
          ...val,
          precoFaixa:
            (solucaoAtual && solucaoAtual.preco) || val.preco || undefined,
          custoFaixa:
            (solucaoAtual && solucaoAtual.custo) || val.custo || undefined,
          solucaoFaixaid:
            (solucaoAtual && solucaoAtual.solucaoFaixaid) || undefined,
        };
      });
    },
    onConfirm() {
      this.setLoading(true);
      var proposta = {
        municipioId: this.$route.params.id,
        usuarioCriacao: this.user.usuarioId,
        valorTotal: this.getValorTotal,
        status: statusPropostasEnum.emProcessamento,
        municipioPropostaGrupoSolucaoDTO: this.selectedSolutions.map(
          (item) => ({
            idSolucao: item.solucaoId,
            idGrupoSolucao:
              (item.grupoSolucao && item.grupoSolucao.grupoSolucaoId) ||
              item.grupoSolucaoId,
            solucaoExtraId: item.municipioPropostaSolucoesExtrasId,
          })
        ),
        contrapartidaSebrae: this.getValorContrapartidaSebrae,
        investimentoMunicipio: this.getValorInvestimentoMunicipal,
      };
      propostaApi
        .gerarProposta(proposta)
        .then((data) => {
          const novaPropostaId = data.headers?.["x-municipio-proposta-id"];
          this.fazerDownloadRelatorio(
            data.data,
            `Proposta - ${this.city}`,
            novaPropostaId
          );
        })
        .catch((err) => {
          this.$notification.error("Erro ao gerar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    async registrarEdicaoProposta(item, novaPropostaId) {
      let propostaId = novaPropostaId;

      if (!propostaId) {
        try {
          const propostas = await propostaApi.getPropostasPorMunicipioId(
            this.$route.params.id
          );
          const propostasOrdenadas = (propostas.data || [])
            .map((proposta) => proposta.municipioPropostaId)
            .filter((id) => id !== item.municipioPropostaId);
          propostaId = propostasOrdenadas.length
            ? Math.max(...propostasOrdenadas)
            : null;
        } catch (error) {
          console.log("Erro ao obter proposta gerada", error);
        }
      }

      if (!propostaId) {
        this.setLoading(false);
        return;
      }

      item.status = statusPropostasEnum.editada;
      item.justificativaRecusa = `Substituída pela proposta número: ${propostaId}`;
      propostaApi
        .update(item)
        .then(() => {
          this.$emit("onLoad");
          this.dialog = false;
        })
        .catch((err) => {
          console.log("Erro no cancelar ", err);
          this.setLoading(false);
        });
    },
    deleteProposta(item) {
      this.selectedSolutions = this.selectedSolutions.filter(
        (val) => item !== val
      );
    },
    changeSolution(solutions) {
      this.selectedSolutions = solutions.reverse();
    },
    loadSolutions() {
      this.setLoading(true);
      solutionAPI.list({}).then((res) => {
        this.setLoading(false);

        this.solutions = res.data;

        this.addSolucao(this.edit);
      });
    },
    addPreco(data, solucoesExtras) {
      const solucoesPrecos =
        (this.faixa &&
          this.faixa.solucoesFaixasDTO &&
          this.faixa.solucoesFaixasDTO.length &&
          this.faixa.solucoesFaixasDTO) ||
        [];

      this.atualSolutions = data.filter(
        (val) =>
          !this.combosEssecialSolutionsId.some((ob) => val.solucaoId == ob)
      );

      this.atualSolutions = this.atualSolutions.filter((val) =>
        solucoesPrecos.some((item) => item.solucaoId == val.solucaoId)
      );

      this.atualSolutions = [...this.atualSolutions, ...solucoesExtras];

      if (this.atualSolutions && this.atualSolutions.length) {
        this.atualSolutions = this.atualSolutions.map((val) => {
          const solucaoAtual = solucoesPrecos.find(
            (a) => a.solucaoId == val.solucaoId
          );

          return {
            ...val,
            precoFaixa:
              (solucaoAtual && solucaoAtual.preco) || val.preco || undefined,
            custoFaixa:
              (solucaoAtual && solucaoAtual.custo) || val.custo || undefined,
            solucaoFaixaid:
              (solucaoAtual && solucaoAtual.solucaoFaixaid) || undefined,
          };
        });
      }
    },
    async loadSolutionsByGroup(val) {
      try {
        this.atualSolutions = [];
        const data = await solutionAPI.getSolutions([val]);

        let solucoesExtrasGrupo = [];

        if (this.solucoesExtrasLocal && this.solucoesExtrasLocal.length > 0) {
          solucoesExtrasGrupo = this.solucoesExtrasLocal.filter(
            (item) => val == item.grupoSolucaoId
          );
        }

        this.addPreco(data.data, solucoesExtrasGrupo);
      } catch (error) {
        console.log("🚀 ~ loadSolutionsByGroup ~ error:", error);
      }
    },
    fazerDownloadRelatorio(file, nomeArquivo, novaPropostaId) {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `${nomeArquivo} - ${moment().format("DD.MM.YYYY.HH.mm")}.pdf`
      );

      document.body.appendChild(fileLink);
      fileLink.click();

      if (this.edit) {
        this.registrarEdicaoProposta(this.edit, novaPropostaId);
      }
      else {
        this.$notification.success("Proposta gerada com sucesso!");

        this.$emit("onLoad");
        this.dialog = false;
        this.setLoading(false);
      }
    },
    changeGroupSolution(grupoSolucaoId) {
      this.atualGrupoSolucao = grupoSolucaoId;
      this.loadSolutionsByGroup(this.atualGrupoSolucao);
    },
    openCriarSolucaoExtra() {
      if (!this.atualGrupoSolucao) {
        this.$notification.error("Selecione um eixo antes de criar a solução.");
        return;
      }
      this.$refs.modalSolucaoExtra.openWithGrupo(this.atualGrupoSolucao);
    },
    handleSolucaoExtraCreated(novaSolucao) {
      if (
        novaSolucao &&
        novaSolucao.municipioPropostaSolucoesExtrasId &&
        novaSolucao.grupoSolucaoId
      ) {
        this.pendingExtraSelectionId =
          novaSolucao.municipioPropostaSolucoesExtrasId;
      }
      this.refreshSolucoesExtras();
      this.$emit("refreshSolucoesExtras");
    },
    fechar() {
      if (!this.edit) {
        this.selectedSolutions = [];
        this.atualGrupoSolucao = null;
      }

      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.novaProposta {
  max-height: 80%;
}
.comboEssencial {
  color: var(--corPrimaria);
  cursor: pointer;
}
.combo {
  .header {
    background: black;
    margin-left: -28px;
    width: 135%;
    text-align: center;
    margin-top: -16px;
    margin-bottom: 5px;
  }
}
</style>
